import Vue from "vue";
import Pusher from "pusher-js";
import VueEcho from "vue-echo-laravel";
import axios from "axios";

const options = {
  broadcaster: "pusher",
  encrypted: true,
  key: import.meta.env.VITE_PUSHER_APP_KEY,
  cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
  wsPort: 6001,
  wssPort: 6001,
  enableStats: false,
  enabledTransports: ["ws", "wss"],
  authorizer: (channel) => {
    return {
      authorize: (socketId, callback) => {
        axios
          .post("/broadcasting/auth", {
            socket_id: socketId,
            channel_name: channel.name,
          })
          .then((response) => {
            callback(false, response.data);
          })
          .catch((error) => {
            callback(true, error);
          });
      },
    };
  },
};

// Development configuration
Pusher.logToConsole = false;
options.enableStats = false;
options.wsHost = "dksnap.com";

Vue.use(VueEcho, options);
